<!--
 
 !-->
<template>
  <div class="collapse-input-style">
    <a-form layout="vertical">
      <template v-for="(item, index) in options">
        <div v-if="isShowForm(item, '[object Object]')" :key="index">
          <!-- :class=" item.name === 'dataType' ? 'hide' : '' " -->
          <a-form-item
            v-if="
              inputShow[item.name] &&
              item.type != 'dycustComponents' &&
              item.type != 'dynamic-add-table'&&item.name !== 'dataType'&&item.name !== 'choose-fields'
            "
            :label="item.label"
            :prop="item.name"
            :required="item.required"
            style="margin-bottom: 8px"
            :class="item.name === 'staticData' ? 'hide' : ''"
          >
            <a-input-number
              v-if="item.type == 'el-input-number'"
              style="width: 100%"
              :disabled="!!item.disabled ? true : false"
              v-model.trim="formData[item.name]"
              @change="changed($event, item.name)"
            />
            <!-- 百分号的特殊处理 -->
            <a-input-number
              v-if="item.type == 'el-input-number-percent'"
              :default-value="100"
              :min="25"
              :max="100"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')"
              style="width: 100%"
              v-model.trim="formData[item.name]"
              @change="changed($event, item.name)"
            />
            <a-input
              v-if="item.type == 'el-input-text'"
              v-model.trim="formData[item.name]"
              type="text"
              placeholder="请输入内容"
              allowClear
              @change="changed($event, item.name)"
            />

            <a-input
              v-if="item.type == 'el-input-textarea'"
              v-model.trim="formData[item.name]"
              type="textarea"
              auto-size
              placeholder="请输入内容"
              @change="changed($event, item.name)"
            />

            <a-switch
              v-if="item.type == 'el-switch'"
              v-model="formData[item.name]"
              placeholder="请输入内容"
              @change="changed($event, item.name)"
            />
            <ColorPicker
              v-if="item.type == 'vue-color'"
              v-model="formData[item.name]"
              @change="(val) => changed(val, item.name)"
            />
            <customUpload
              v-if="item.type == 'custom-upload'"
              v-model="formData[item.name]"
              @change="changed($event, item.name)"
            />

            <a-radio-group
              v-if="item.type == 'el-radio-group'"
              v-model="formData[item.name]"
              @change="(val) => changed(val, item.name)"
            >
              <a-radio
                v-for="itemChild in item.selectOptions"
                :key="itemChild.code"
                :value="itemChild.code"
                >{{ itemChild.name }}</a-radio
              >
            </a-radio-group>

            <a-select
              v-if="item.type == 'el-select'"
              v-model="formData[item.name]"
              allowClear
              placeholder="请选择"
              @change="(val) => changed(val, item.name)"
            >
              <a-select-option
                v-for="itemChild in item.selectOptions"
                :key="itemChild.code"
                :value="itemChild.code"
              >
                {{ itemChild.name }}
              </a-select-option>
            </a-select>
            <TagDateRange v-if="item.type == 'a-range-picker'" v-model="formData[item.name]" 
              :timeSelector="formData.timeSelector" @change="(value, timeSelector) => handleChange(value, timeSelector, item.name)">
              <template slot="tagLabel">
                <span style="font-size: 12px">动态日期：</span>
              </template>
            </TagDateRange>

            <a-slider
              v-if="item.type == 'el-slider'"
              v-model="formData[item.name]"
              @change="(val) => changed(val, item.name)"
            />

            <!-- <a-button
              v-if="item.type == 'el-button'"
              type="primary"
              plain
              @click="addStaticData"
              >编辑</a-button
            > -->
            <div v-if="item.type === 'style-type-change'">
              <a-radio-group v-model="formData[item.name]" button-style="solid" @change="styleChange($event, item.name)">
                <a-radio-button value="normal">日常系</a-radio-button>
                <a-radio-button value="dark">暗黑系</a-radio-button>
              </a-radio-group>
            </div>
            <!-- 弹窗 -->
            <a-modal
              :centered="true"
              title="代码编辑"
              :visible.sync="dialogVisibleStaticData"
              width="50%"
              :before-close="handleClose"
            >
              <vue-json-editor
                v-model="formData[item.name]"
                :show-btns="false"
                :mode="'code'"
                lang="zh"
                class="my-editor"
              />
              <span slot="footer" class="dialog-footer">
                <a-button @click="dialogVisibleStaticData = false">取 消</a-button>
                <a-button type="primary" @click="saveData">确 定</a-button>
              </span>
            </a-modal>
          </a-form-item>
            <!-- :key="item.dictKey+currentTempIndex" -->
          <dynamicComponents
            v-if="item.type == 'dycustComponents' && inputShow[item.name]"
            v-model="formData[item.name]"
            :chart-type="item.chartType"
            ref="dynamicComponents"
            :key="item.dictKey+currentTempIndex"
            :dict-key="item.dictKey"
            @change="changed($event, item.name)"
          />
          <dynamic-add-table
            v-if="item.type == 'dynamic-add-table' && inputShow[item.name]"
            v-model="formData[item.name]"
            :chart-type="item.chartType"
            :key="item.uuid"
            @change="changed($event, item.name)"
          />
          <choose-fields
            v-if="item.type == 'choose-fields' && inputShow[item.name]"
            v-model="formData[item.name]"
            @change="changed($event, item.name)"
          />
        </div>
        <div v-else-if="isShowForm(item, '[object Array]')" :key="'a-' + index">
          <template v-if="widgetType && widgetType === 'widget-barlinechart'">
            <template v-if="index === 1">
            <a-collapse accordion>
              <a-collapse-panel
                v-for="(itemChild, indexChild) in item"
                :key="indexChild"
                :header="itemChild.name"
              >
                
                <template v-for="(itemChildList, idx) in itemChild.list">
                  <a-form-item
                    :key="idx"
                    :label="itemChildList.label"
                    :prop="itemChildList.name"
                    :required="itemChildList.required"
                    class="mb-8"
                  >
                    <a-input-number
                      v-if="itemChildList.type == 'el-input-number'"
                      style="width: 100%"
                      v-model="formData[itemChildList.name]"
                      :placeholder="itemChildList.placeholder"
                      @change="changed($event, itemChildList.name)"
                    />
                    <a-input
                      v-if="itemChildList.type == 'el-input-text'"
                      v-model.trim="formData[itemChildList.name]"
                      type="text"
                      placeholder="请输入内容"
                      allowClear
                      @change="changed($event, itemChildList.name)"
                    />

                    <a-input
                      v-if="itemChildList.type == 'el-input-textarea'"
                      v-model.trim="formData[itemChildList.name]"
                      type="textarea"
                      rows="2"
                      placeholder="请输入内容"
                      @change="changed($event, itemChildList.name)"
                    />

                    <a-switch
                      v-if="itemChildList.type == 'el-switch'"
                      v-model="formData[itemChildList.name]"
                      placeholder="请输入内容"
                      @change="changed($event, itemChildList.name)"
                    />

                    <ColorPicker
                      v-if="itemChildList.type == 'vue-color'"
                      v-model="formData[itemChildList.name]"
                      @change="(val) => changed(val, itemChildList.name)"
                    />

                    <a-upload
                      v-if="itemChildList.type == 'el-upload-picture'"
                      action="https://jsonplaceholder.typicode.com/posts/"
                      list-type="picture-card"
                    />

                    <a-radio-group
                      v-if="itemChildList.type == 'el-radio-group'"
                      v-model="formData[itemChildList.name]"
                      @change="(val) => changed(val, itemChildList.name)"
                    >
                      <a-radio
                        v-for="it in itemChildList.selectOptions"
                        :key="it.code"
                        :value="it.code"
                        >{{ it.name }}</a-radio
                      >
                    </a-radio-group>

                    <a-select
                      v-if="itemChildList.type == 'el-select'"
                      v-model="formData[itemChildList.name]"
                      allowClear
                      placeholder="请选择"
                      @change="(val) => changed(val, itemChildList.name)"
                    >
                      <a-select-option
                        v-for="it in itemChildList.selectOptions"
                        :key="it.code"
                        :value="it.code"
                      >
                        {{ it.name }}
                      </a-select-option>
                    </a-select>

                    <a-slider
                      v-if="itemChildList.type == 'el-slider'"
                      v-model="formData[itemChildList.name]"
                      @change="(val) => changed(val, itemChildList.name)"
                    />
                  </a-form-item>
                  <customColorComponents
                    v-if="itemChildList.type == 'customColor'"
                    :key="'b-' + idx"
                    v-model="formData[itemChildList.name]"
                    @change="changed($event, itemChildList.name)"
                  />
                </template>
              </a-collapse-panel>
            </a-collapse>
            </template>
          </template>
          <template v-else>
            <a-collapse accordion>
              <a-collapse-panel
                v-for="(itemChild, indexChild) in item"
                :key="indexChild"
                :header="itemChild.name"
              >
                
                <template v-for="(itemChildList, idx) in itemChild.list">
                  <a-form-item
                    :key="idx"
                    :label="itemChildList.label"
                    :prop="itemChildList.name"
                    :required="itemChildList.required"
                    class="mb-8"
                  >
                    <a-input-number
                      v-if="itemChildList.type == 'el-input-number'"
                      style="width: 100%"
                      v-model="formData[itemChildList.name]"
                      :placeholder="itemChildList.placeholder"
                      @change="changed($event, itemChildList.name)"
                    />
                    <a-input
                      v-if="itemChildList.type == 'el-input-text'"
                      v-model.trim="formData[itemChildList.name]"
                      type="text"
                      placeholder="请输入内容"
                      allowClear
                      @change="changed($event, itemChildList.name)"
                    />

                    <a-input
                      v-if="itemChildList.type == 'el-input-textarea'"
                      v-model.trim="formData[itemChildList.name]"
                      type="textarea"
                      rows="2"
                      placeholder="请输入内容"
                      @change="changed($event, itemChildList.name)"
                    />

                    <a-switch
                      v-if="itemChildList.type == 'el-switch'"
                      v-model="formData[itemChildList.name]"
                      placeholder="请输入内容"
                      @change="changed($event, itemChildList.name)"
                    />

                    <ColorPicker
                      v-if="itemChildList.type == 'vue-color'"
                      v-model="formData[itemChildList.name]"
                      @change="(val) => changed(val, itemChildList.name)"
                    />

                    <a-upload
                      v-if="itemChildList.type == 'el-upload-picture'"
                      action="https://jsonplaceholder.typicode.com/posts/"
                      list-type="picture-card"
                    />

                    <a-radio-group
                      v-if="itemChildList.type == 'el-radio-group'"
                      v-model="formData[itemChildList.name]"
                      @change="(val) => changed(val, itemChildList.name)"
                    >
                      <a-radio
                        v-for="it in itemChildList.selectOptions"
                        :key="it.code"
                        :value="it.code"
                        >{{ it.name }}</a-radio
                      >
                    </a-radio-group>

                    <a-select
                      v-if="itemChildList.type == 'el-select'"
                      v-model="formData[itemChildList.name]"
                      allowClear
                      placeholder="请选择"
                      @change="(val) => changed(val, itemChildList.name)"
                    >
                      <a-select-option
                        v-for="it in itemChildList.selectOptions"
                        :key="it.code"
                        :value="it.code"
                      >
                        {{ it.name }}
                      </a-select-option>
                    </a-select>

                    <a-slider
                      v-if="itemChildList.type == 'el-slider'"
                      v-model="formData[itemChildList.name]"
                      @change="(val) => changed(val, itemChildList.name)"
                    />
                  </a-form-item>
                  <customColorComponents
                    v-if="itemChildList.type == 'customColor'"
                    :key="'b-' + idx"
                    v-model="formData[itemChildList.name]"
                    @change="changed($event, itemChildList.name)"
                  />
                </template>
              </a-collapse-panel>
            </a-collapse>
          </template>
        </div>
      </template>
    </a-form>
    <div class="fixed-bottom" v-if="['widget-time', 'widget-image', 'widget-text'].indexOf(widgetType) == -1">
      <a-button type="primary" :loading="applyLoading" @click="applyData">应用</a-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ColorPicker from "./colorPicker.vue";
import vueJsonEditor from "vue-json-editor";
import "codemirror/lib/codemirror.css"; // 核心样式
import "codemirror/theme/cobalt.css"; // 引入主题后还需要在 options 中指定主题才会生效
// language
import "codemirror/mode/vue/vue.js";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/mode/sql/sql.js";
import "codemirror/mode/shell/shell.js";
import dynamicComponents from "./dynamicComponents/dynamicComponents.vue";
import customColorComponents from "./customColorComponents";
import dynamicAddTable from "./dynamicAddTable.vue";
import customUpload from "./customUpload.vue";
import TagDateRange from "@/components/TagDateRange";
import { setDefaultValue } from '@/utils/modelMethods.js'
import ChooseFields from "./dynamicComponents/chooseFields";

export default {
  name: "DynamicForm",
  components: {
    ColorPicker,
    vueJsonEditor,
    dynamicComponents,
    customColorComponents,
    dynamicAddTable,
    customUpload,
    TagDateRange,
    ChooseFields
  },
  props: {
    options: Array,
    value: {
      type: [Object],
      default: () => {},
    },
    widgetType: String,
    comIndex: Number,
  },
  data() {
    return {
      formData: {},
      inputShow: {}, // 控制表单是否显示
      dialogVisibleStaticData: false,
      validationRules: "",
      optionsJavascript: {
        mode: "text/javascript",
        tabSize: 2, // 缩进格式
        lineNumbers: true, // 显示行号
        line: true,
        styleActiveLine: true, // 高亮选中行
        hintOptions: {
          completeSingle: true, // 当匹配只有一项的时候是否自动补全
        },
      },
    };
  },
  computed:{
    ...mapGetters({      
      currentTempIndex: "getCurrentTempIndex",
      applyLoading: "applyLoading",
    }),
  },
  watch: {
    options: {
      handler(val) {
        console.log('optionsWatch')
        this.formData = setDefaultValue(this.options);
        this.isShowData();
      },
      deep: true
    },
    comIndex(val) {
      console.log(val, '------comIndex');
    }
  },
  created() {
    this.isShowData();
    this.formData = setDefaultValue(this.options || []);
  },
  mounted() {},
  methods: {
    styleChange(e, name) {
      this.$confirm({
        title: '提示',
        content: `整体页面风格将切换为${e.target.value === 'dark'?'暗黑':'日常'}系，字体颜色和背景颜色将会被被覆盖，请确认是否切换？`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.formData.style = e.target.value
          if(e.target.value === 'dark') {
            this.formData.backgroundColor = '#1F1F1F'
          } else {
            this.formData.backgroundColor = '#FBFCFE'
          }
          this.changed(e.target.value, 'style')
          this.$emit('styleChange', e.target.value)
        },
        onCancel: () => {
          this.formData.style = e.target.value === 'dark'?'normal':'dark'
        }
      });
    },
    dateChange(val) {
      this.changed('', 'timeSelector')
      this.changed(val, item.name)
    },
    disabledDate(current) {
      return current && current > moment().endOf("day");
    },
    // 无论哪个输入框改变 都需要触发事件 将值回传
    changed(val, key) {
      console.log(val, key)
      // debugger;
      if (val&&val.extend) {
        this.$set(this.formData, key, val.value);
      } else {
        const value = !!val?.target ? val.target.value : val;
        this.$set(this.formData, key, value);
      }
      this.$emit("onChanged", this.formData);
      // key为当前用户操作的表单组件
      for (let i = 0; i < this.options.length; i++) {
        let item = this.options[i];
        if (item.relactiveDom == key) {
          // val.target.value 对于dynamicComponents组件的值 进行兼容显示；
          this.inputShow[item.name] =
            val == item.relactiveDomValue || val.target.value == item.relactiveDomValue;
          this.inputShow = Object.assign({}, this.inputShow);
        }
      }
    },
    handleChange(value, timeSelector, name) {
      this.changed(timeSelector, 'timeSelector')
      this.changed(value, name)
    },
    saveData() {
      this.$emit("onChanged", this.formData);
      this.dialogVisibleStaticData = false;
    },
    // 静态数据
    addStaticData() {
      this.dialogVisibleStaticData = true;
    },
    handleClose() {
      this.dialogVisibleStaticData = false;
    },
    // 组件属性 数据是否展示动态还是静态数据
    isShowData() {
      let currentData = {};
      const data = [];
      for (let i = 0; i < this.options.length; i++) {
        // 添加默认的inputShow值
        this.inputShow[this.options[i].name] = true;
        if (this.options[i].selectValue) {
          currentData = this.options[i];
        } else {
          data.push(this.options[i]);
        }
      }
      data.forEach((el) => {
        // debugger;
        if (el.relactiveDomValue != currentData.value) {
          this.inputShow[el.name] = false;
        }
      });
    },
    // 是否显示 那种格式
    isShowForm(val, type) {
      return Object.prototype.toString.call(val) == type;
    },
    applyData() {
      if(this.$refs.dynamicComponents&&this.$refs.dynamicComponents[0]) {
        this.$refs.dynamicComponents[0].applyData();
      } else {
        this.$emit("applyData", this.formData);
        console.log(this.formData)
      }
    }
  },
};
</script>

<style scoped lang="less">
.collapse-input-style {
  padding-right: 16px;
  padding-bottom: 47px;
}
.code-mirror {
  width: 100%;
  height: 100% !important;
}
/deep/ .ant-form-item {
  .ant-form-item-label > label {
    color: #677392;
    font-weight: 400;
  }
}
/deep/ textarea.ant-input {
  resize: none;
}
.fixed-bottom{
  position: absolute;
  left: 0;
  bottom: 0;
  background: #fff;
  padding-top: 15px;
  width: 100%;
  z-index: 100;
}
</style>
